// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-item-propmt[data-v-795d9cb9]{margin-top:5px;display:flex;align-items:flex-start}.form-item-propmt .icon[data-v-795d9cb9]{color:#e6a23c;margin-right:7px;font-size:18px}.form-item-propmt .propmt[data-v-795d9cb9]{font-size:13px;color:#409eff;line-height:20px}", ""]);
// Exports
module.exports = exports;
